
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.5 19c0 3.079-2.998 6.5-6.137 6.5-3.139 0-5.683-3.471-5.683-6.55 0-3.079 2.544-6.45 5.683-6.45S28.5 15.921 28.5 19z","fill":"#3084B9"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.776 25.6l-5.682-.975L9.5 19c0-3.106 3.138-6.5 6.276-6.5 3.139 0 5.683 3.394 5.683 6.5 0 3.107-2.544 6.6-5.683 6.6z","fill":"#F9B621"}}),_c('path',{attrs:{"d":"M29.254 8.333c5.777 5.777 5.777 15.144 0 20.921-5.777 5.777-15.144 5.777-20.921 0-5.777-5.777-5.777-15.144 0-20.921 5.777-5.777 15.144-5.777 20.921 0","stroke":"#494949","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M36 36l-6-6","stroke":"#494949","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    